import { HTTP } from "@/shared/services/Http.service";
import { URL_API_AUTENTICACION_V2 } from "../../utils/Url.utils";
import type { 
    AboutMeRequest, 
    ChangePasswordRequest, 
    ForgotPasswordRequest, 
    LoginRequest, 
    LoginResponse, 
    LogoutRequest, 
    RefreshTokenRequest,
    RefreshTokenResponse, 
    RegisterRequest, 
    ResetPasswordRequest, 
    RevokeAllRequest, 
    RevokeSessionRequest, 
    ServerTime, 
    SessionsRequest,
    Verify2FARequest 
} from "../../types/interfaces/AutenticacionV2";
import type { DataUserValidateTokenResetPassword, ValidateTokenResetPasswordResponse } from "../../../../shared/types/interfaces/Source";

const http = HTTP();

function Register(data: RegisterRequest):Promise<any>{
    return http.Post(`${URL_API_AUTENTICACION_V2.REGISTER}`, {body: data, skipAuth: true})
}
function Login(data: LoginRequest):Promise<LoginResponse>{
    return  http.Post(`${URL_API_AUTENTICACION_V2.LOGIN}`, {body: data})
}
function RefreshToken(data: RefreshTokenRequest):Promise<RefreshTokenResponse>{
    return http.Post(`${URL_API_AUTENTICACION_V2.REFRESH_TOKEN}`, {body: data, skipAuth: true})
}
function Logout(data: LogoutRequest):Promise<any>{
    return http.Post(`${URL_API_AUTENTICACION_V2.LOGOUT}`, {body: data})
}
function AboutMe(data: AboutMeRequest):Promise<any>{
    return http.Get(`${URL_API_AUTENTICACION_V2.ABOUT_ME}`, {body: data})
}
function ChangePassword(data: ChangePasswordRequest):Promise<any>{
    return http.Post(`${URL_API_AUTENTICACION_V2.CHANGE_PASSWORD}`, {body: data})
}
function ForgotPassword(data: ForgotPasswordRequest):Promise<any>{
    return http.Post(`${URL_API_AUTENTICACION_V2.FORGOT_PASSWORD}`, {body: data})
}
function ResetPassword(data: ResetPasswordRequest):Promise<any>{
    return http.Post(`${URL_API_AUTENTICACION_V2.RESET_PASSWORD}`, {body: data})
}
function Session(data: SessionsRequest):Promise<any>{
    return http.Get(`${URL_API_AUTENTICACION_V2.SESSIONS}`, {body: data})
}
function RevokeSession(data: RevokeSessionRequest):Promise<any>{
    return http.Delete(`${URL_API_AUTENTICACION_V2.REVOKE_SESSION}`, {body: data})
}
function RevokeAll():Promise<any>{
    return http.Post(`${URL_API_AUTENTICACION_V2.REVOKE_ALL}`, {body: {}})
}

function Verify2FA(data: Verify2FARequest):Promise<any>{
    return http.Post(`${URL_API_AUTENTICACION_V2.VERIFICAR_2FA_V2}`, {body: data})
}

function ValidateTokenResetPassword(token: string):Promise<ValidateTokenResetPasswordResponse>{
    return http.Get(`${URL_API_AUTENTICACION_V2.VALIDATE_TOKEN_RESET_PASSWORD}?token=${ token }`, { skipAuth: true })
}
/** Recupera la hora del servidor: fecha y hora actual en formato ISO 8601 */
function getServerTime():Promise<{serverTime: ServerTime}>{
    return http.Get(`${URL_API_AUTENTICACION_V2.TIME_V2}`)
}

export{
    Register,
    Login,
    RefreshToken,
    Logout,
    AboutMe,
    ChangePassword,
    ForgotPassword,
    ResetPassword,
    Session,
    RevokeSession,
    RevokeAll,
    Verify2FA,
    ValidateTokenResetPassword,
    getServerTime
}